<template>
    <v-sheet v-if="isUserGranted">
        <v-tabs v-model="tab">
            <template v-for="tab in tabs">
                <v-tab :key="tab.value"> {{ tab.text }} </v-tab>
            </template>
        </v-tabs>
        <v-divider class="mb-24 mb-lg-48" />

        <v-tabs-items v-model="tab">
            <template v-for="(item, index) in tabs">
                <v-tab-item :key="item.value">
                    <component
                        :is="`body-${item.value.toLowerCase()}`"
                        v-bind="{
                            isTabActive: tab == index,
                        }"
                    />
                </v-tab-item>
            </template>
        </v-tabs-items>
    </v-sheet>
</template>

<script>
import { mapGetters, mapState } from "vuex";

import BodyEmployees from "./body/body-employees.vue";
import BodyEmployers from "./body/body-employers.vue";
import BodyInterview from "./body/body-interview.vue";
import BodyMatchings from "./body/body-matchings.vue";
import BodySchedules from "./body/body-schedules.vue";
import BodyStatistic from "./body/body-statistic.vue";

const TABS = {
    EMPLOYERS: { value: "EMPLOYERS", text: "참여기업 정보" },
    EMPLOYEES: { value: "EMPLOYEES", text: "개인회원 정보" },
    MATCHINGS: { value: "MATCHINGS", text: "매칭정보" },
    INTERVIEW: { value: "INTERVIEW", text: "면접정보" },
    SCHEDULES: { value: "SCHEDULES", text: "면접일정" },
    STATISTIC: { value: "STATISTIC", text: "프로그램 요약" },
};

export default {
    components: {
        BodyEmployees,
        BodyEmployers,
        BodyInterview,
        BodyMatchings,
        BodySchedules,
        BodyStatistic,
    },
    data: () => ({
        tab: 0,
    }),
    computed: {
        ...mapState("expo", ["program", "employee", "employer"]),
        ...mapGetters("expo", ["isUserHost", "isUserEmployee", "isUserEmployer"]),
        ...mapGetters(["_user", "isUserLoggedIn", "doesUserHaveConsoleScope"]),

        isUserGranted() {
            return this.doesUserHaveConsoleScope || this.isUserHost || this.isUserEmployee || this.isUserEmployer;
        },

        tabs() {
            let ITEMS = { ...TABS };

            if (this.isUserHost || this.doesUserHaveConsoleScope) {
                delete ITEMS.SCHEDULES;
            }

            if (this.isUserEmployee) {
                delete ITEMS.EMPLOYEES;
                delete ITEMS.STATISTIC;
            }

            if (this.isUserEmployer) {
                delete ITEMS.EMPLOYERS;
                delete ITEMS.STATISTIC;
            }

            return Object.values(ITEMS);
        },
    },
};
</script>

<style>
</style>